<div fxLayout="column">
  <div fxLayout="row" class="font-size-18 text-bold" fxLayoutAlign="left center">
    <span class="success-icon"></span>
    <span class="ml-12 text-color-green">
    {{data.title}}
    </span>
  </div>
  <div class="mt-20">
    <span>
       {{data.content}}
    </span>
  </div>
  <div fxLayoutAlign="end right" class="font-size-18 text-bold text-color--content-600 mt-28 mr-24"
  (click)="dialogRef.close(true)">
    <span class="close-button artstuff-pointer">{{data.close}}</span>
  </div>
</div>
